export default {
  SET_STATUS(state, status) {
    state.requestStatus = status;
  },

  SET_IS_FETCHING(state, isFetching) {
    state.isFetching = isFetching;
  },

  SET_RESPONSE(state, data) {
    state.data = data;
  },
};
